export default {
    name: 'platform',
    routes: {
        items: [
            {
                path: '/platform',
                redirect: { name: 'platform-cpos' },
            },
            {
                path: '/platform/cpos',
                name: 'platform-cpos',
                component: () => import('./cpos-list.page.vue'),
                meta: {
                    title: 'CPOs',
                    icon: 'icon-business-account',
                    sidebar: { label: 'CPOs', order: 1 },
                },
            },
            {
                path: '/platform/cpos/new',
                name: 'platform-cpo-new',
                component: () => import('./add-cpo-wizard.page.vue'),
                meta: {
                    title: 'Add a CPO',
                },
            },
            {
                path: '/platform/cpos/:orgKey',
                name: 'platform-cpo-detail',
                component: () => import('./cpo-detail.page.vue'),
                props: true,
                meta: {
                    title: 'CPO',
                },
            },
            {
                path: '/platform/users',
                name: 'platform-users',
                component: () => import('./platform-users.page.vue'),
                meta: {
                    title: 'Users',
                    icon: 'icon-users',
                    sidebar: { label: 'Users', order: 2 },
                },
            },
        ],
    },
};
